import { useRef } from "react";

/**
 * 3D tilt-on-hover wrapper. Tracks mouse over the element and applies
 * a subtle perspective rotation, plus a moving gold glow.
 */
const TiltCard = ({ children, className = "", maxTilt = 8, glow = true, ...rest }) => {
  const ref = useRef(null);
  const rafRef = useRef(null);

  const handleMove = (e) => {
    const node = ref.current;
    if (!node) return;
    const rect = node.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width; // 0..1
    const y = (e.clientY - rect.top) / rect.height; // 0..1
    const rotY = (x - 0.5) * 2 * maxTilt;
    const rotX = -(y - 0.5) * 2 * maxTilt;
    cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(() => {
      node.style.transform = `perspective(1100px) rotateX(${rotX}deg) rotateY(${rotY}deg) translateZ(15px)`;
      if (glow) {
        node.style.setProperty("--glow-x", `${x * 100}%`);
        node.style.setProperty("--glow-y", `${y * 100}%`);
      }
    });
  };

  const handleLeave = () => {
    const node = ref.current;
    if (!node) return;
    cancelAnimationFrame(rafRef.current);
    node.style.transform = "perspective(1100px) rotateX(0) rotateY(0) translateZ(0)";
  };

  return (
    <div
      ref={ref}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      className={`relative transition-transform duration-500 ease-out will-change-transform ${className}`}
      style={{
        transformStyle: "preserve-3d",
        backgroundImage: glow
          ? `radial-gradient(600px circle at var(--glow-x, 50%) var(--glow-y, 50%), rgba(255,215,0,0.12), transparent 40%)`
          : undefined,
      }}
      {...rest}
    >
      {children}
    </div>
  );
};

export default TiltCard;
